
import React from 'react';
import './AboutUs.css';
const AboutUs = () => {
    return (
        <>
        
        <div id="about" className="container">
        <div className="star">
            
        <h1 style={{fontSize: "2.25em"}}>About Us!</h1>
        {/* <div className="underline"></div> */}
         <div className="about-us">
            <div className="about-us-para">
                <h3>Who we are</h3>
                <span>
                We are the community for all the talents out there, a place where they can  learn, build and grow themselves. Working with the motto to discover the talent of tomorrow, we believe that every person should get a platform  to showcase their unique talent.
                </span>
            </div>
            <div className="about-us-para">
                <h3>What we do</h3>
                <span>
                An online platform which works to refine raw talents through diverse opportunities like workshops, mentorship programmes, contests and to even provide freelancing options. Protal always aims and works to provide the best stage to all the dreamers.
                </span>
            </div>
            <div className="about-us-para">
                <h3>What you are supporting</h3>
                <span>
                7 billion people, 7 billion unique worlds each with its own identity and talents. With this vision in mind, Protal endeavours to bring talents hidden in sand dunes. An organisation working to relish the growth of talented people and making them unstoppable. 
                </span>
            </div>
            </div>
        </div>  
        </div>
        
          
        </>
    );
};

export default AboutUs;
